import { render } from "./productlist.vue?vue&type=template&id=12832c52"
import script from "./productlist.vue?vue&type=script&lang=js"
export * from "./productlist.vue?vue&type=script&lang=js"

import "./productlist.vue?vue&type=style&index=0&id=12832c52&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__